


































































































































































import {
  computed,
  defineComponent,
  reactive,
  Ref,
  ref,
} from '@vue/composition-api';
import { useRouter, useFormat } from '@ideavivat/vivat-2';
import _ from 'lodash';
import { useMutation, useQuery } from '@vue/apollo-composable';
import PrettyCheck from 'pretty-checkbox-vue/check';

import CommonHubSelector from '@/components/CommonHubSelector.vue';
import CommonDeliveryStatusSelect from '@/components/Delivery/CommonDeliveryStatusSelect.vue';
import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import CommonIconTop from '@/components/CommonIconTop.vue';
import CommonChip from '@/components/CommonChip.vue';
import CommonTableFooter from '@/components/CommonTableFooter.vue';
import CommonFormWithInvoiceEditor from '@/components/Invoice/CommonFormWithInvoiceEditor.vue';

import orderList from '@/table/invoices/orderList';
import useDelivery from '@/useDelivery';
import useAuth from '@/useAuth';

import getDeliveries from '@/gql/delivery/getDeliveries.gql';
import sumDeliveryFee from '@/gql/invoice/sumDeliveryFee.gql';
import batchDisconnectDeliveries from '@/gql/invoice/batchDisconnectDeliveries.gql';
import useDeliveryAreaCode from '@/useDeliveryAreaCode';
import useDownloadReport from '@/useDownloadReport';
import getVehicles from '@/gql/vehicle/getVehicles.gql';
import CommonAreaCodeSelector from '@/components/Setting/CommonAreaCodeSelector.vue';

const BillList = defineComponent({
  components: {
    CommonHubSelector,
    CommonIconTop,
    CommonChip,
    CommonTableFooter,
    CommonDeliveryStatusSelect,
    CommonFormWithInvoiceEditor,
    CommonModalWithPreset,
    CommonAreaCodeSelector,
    PrettyCheck,
  },
  setup() {
    const { me } = useAuth();
    const { distanceTypeToChipClass } = useDeliveryAreaCode();
    const { getPDFReport } = useDownloadReport();
    const toCommaFormat = (string: string) => parseFloat(string || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 3 });
    const toCurrency = (str: string | number) => useFormat.number(str).currency();
    const { type, typeDisplay } = useDelivery();

    const forceReload: Ref<boolean> = ref(true);
    // const { result: invoiceStatsResult, loading } = useQuery(getInvoiceStats);
    // const invoiceStats = useResult(invoiceStatsResult, { total: 0 }, (data: any) => data.invoiceStats);

    const editId = ref(-1);

    const selectedItemId: Ref<number[]> = ref([]);
    const selectedItem: Ref<any[]> = ref([]);
    function selectItem(item: any) {
      const hitIndex = selectedItemId.value.indexOf(parseInt(item.id as string, 10));
      if (hitIndex > -1) {
        selectedItemId.value.splice(hitIndex, 1);
        selectedItem.value.splice(hitIndex, 1);
      } else {
        selectedItemId.value.push(parseInt(item.id as string, 10));
        selectedItem.value.push(item);
      }
    }

    const filter = reactive({
      itemInfo: [],
      status: '',
      orderNumber: '',
      orderNumberInput: '',
      deliveryDate: {
        from: undefined,
        to: undefined,
      },
      hub: '',
      type: '',
      area: '',
      vehicle: '',
      mockItem: [
        {
          area: {
            code: '',
          },
          deliveryDiscount: 0,
          deliveryFee: 0,
          deliveryNote: {
            vehicle: {
              id: '',
              license: '',
              vehicleType: '',
            },
          },
          type: '',
        },
      ],
    });

    const clearSelectedItem = () => {
      selectedItemId.value = [];
      selectedItem.value = [];
    };
    const clearDeliveries = () => {
      forceReload.value = false;
      editId.value = -1;
      selectedItemId.value.splice(0);
      selectedItem.value.splice(0);
      forceReload.value = true;
    };

    const modal = ref(null);
    const errorModal = ref(null);

    const createInvoice = () => {
      if (selectedItemId.value.length === 0) (errorModal.value as any).compose();
      else (modal.value as any).open();
    };
    const editInvoice = () => {
      (modal.value as any).open();
    };
    const close = () => {
      (modal.value as any).close();
    };
    const orderNumberInput = _.debounce(() => {
      filter.orderNumber = filter.orderNumberInput;
      clearSelectedItem();
    }, 500);
    function clickDateHandler(date: any) {
      if (filter.deliveryDate.from === useFormat.date(date).computerShortDate()) {
        filter.deliveryDate = {
          from: undefined,
          to: undefined,
        };
      } else {
        filter.deliveryDate = {
          from: useFormat.date(date).computerShortDate(),
          to: useFormat.date(date).computerShortDate(),
        };
      }
      clearSelectedItem();
    }

    const ordersVariable = computed(() => {
      const AND_DELIVERY_NOTE = [];
      const vars: {[key: string]: any} = {
        searchOrderNumber: undefined,
        filterHasDeliveryNote: true,
        filterByType: undefined,
        filterArea: undefined,
        filterByVehicleId: undefined,
        filterWhereDeliveryNote: undefined,
        filterHubId: undefined,

        filter: {
          column: 'STATUS',
          operator: 'IN',
          value: ['SUCCESS', 'HUB'],
          HAS: {
            relation: 'invoice',
            operator: 'LT',
            amount: 1,
          },
        },
      };
      if (me.hub.hubType !== 'MAIN' || filter.hub) vars.filterHubId = (filter.hub as any)?.id || me.hubId;
      if (filter.orderNumber) vars.searchOrderNumber = `%${filter.orderNumber}%`;
      if (filter.type) vars.filterByType = filter.type;
      if (filter.area) {
        vars.filterArea = {
          column: 'CODE',
          operator: 'EQ',
          value: (filter.area as any).code,
        };
      }
      if (filter.vehicle) {
        AND_DELIVERY_NOTE.push({
          column: 'VEHICLE_ID',
          operator: 'EQ',
          value: (filter.vehicle as any).id,
        });
      }
      if (filter.deliveryDate.from) {
        AND_DELIVERY_NOTE.push({
          column: 'DELIVERY_DATE',
          operator: 'EQ',
          value: filter.deliveryDate.from,
        });
      }
      if (AND_DELIVERY_NOTE.length > 0) vars.filterWhereDeliveryNote = { AND: AND_DELIVERY_NOTE };

      return vars;
    });

    const getOrdersResult = (data: any) => data.deliveries;
    const { result: getDeliveriesPaginated } = useQuery(getDeliveries, ordersVariable);
    const deliveriesPaginatorInfo = computed(() => getDeliveriesPaginated?.value?.deliveries?.paginatorInfo?.total || 0);

    const { result: getSumDeliveryFee } = useQuery(sumDeliveryFee, ordersVariable);
    const deliveryFee = computed(() => getSumDeliveryFee?.value?.sumDeliveryFee || 0);

    // Use to disconnect relation
    const confirmDisconnectRelation = ref(null);
    const failedDisconnectRelation = ref(null);
    const singleItemId: Ref<number> = ref(-1);
    const refetchQueries = ['getDeliveries', 'getInvoiceStats', 'sumDeliveryFee'];
    const batchDisconnectDeliveriesMutation = useMutation(batchDisconnectDeliveries, () => ({
      variables: {
        ids: selectedItemId.value,
      },
      refetchQueries,
    }));
    const singleDisconnectDeliveryMutation = useMutation(batchDisconnectDeliveries, () => ({
      variables: {
        ids: [singleItemId.value],
      },
      refetchQueries,
    }));
    function batchDisconnectDeliveriesHandler() {
      batchDisconnectDeliveriesMutation.mutate();
    }
    batchDisconnectDeliveriesMutation.onDone(() => {
      clearDeliveries();
      (confirmDisconnectRelation.value as any).compose({ action: 'บันทึก', entity: 'สำเร็จ' });
    });
    batchDisconnectDeliveriesMutation.onError(() => {
      (failedDisconnectRelation.value as any).compose();
    });
    function singleDisconnectDeliveryHandler(id: number) {
      singleItemId.value = id;
      singleDisconnectDeliveryMutation.mutate();
    }
    batchDisconnectDeliveriesMutation.onDone(() => {
      (confirmDisconnectRelation.value as any).compose({ action: 'บันทึก', entity: 'สำเร็จ' });
      singleItemId.value = -1;
    });
    batchDisconnectDeliveriesMutation.onError(() => {
      (failedDisconnectRelation.value as any).compose();
    });

    return {
      me,

      distanceTypeToChipClass,
      toCurrency,
      toCommaFormat,
      forceReload,
      deliveriesPaginatorInfo,

      modal,
      errorModal,
      editInvoice,
      createInvoice,
      close,
      editId,

      filter,
      orderNumberInput,
      clickDateHandler,

      selectedItemId,
      selectedItem,
      selectItem,
      clearDeliveries,

      orderListOption: orderList,
      ordersVariable,
      getDeliveries,
      deliveryFee,
      getOrdersResult,

      // orderStatusCounter,

      // statusChartValue,

      singleDisconnectDeliveryHandler,
      batchDisconnectDeliveriesHandler,
      confirmDisconnectRelation,

      // To get report
      getPDFReport,

      getVehicles,
      getVehiclesResult: (data: any) => data.vehicles.data,

      type,
      typeDisplay,

      clearSelectedItem,
    };
  },
});

export default BillList;
